import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Tooltip from 'react-bootstrap/Tooltip';
import {envAwarePost,dateToYMD,capitalize} from '../../../util/util'
import { Link,useHistory } from 'react-router-dom';
import {selectTrainerParam} from "../../users/usersSlice"
import useCurrentUser from '../../../hooks/useCurrentUser'
import {getEvents} from '../../../state/events'

{/* add an event modal */ }

function SelectEventType({ selectEventShow, setSelectEventShow }) {
    const dispatch = useDispatch()
    const history = useHistory()
    const isClient = useSelector(state => state.users.current_user.account_type === 'client')
    const clientIdUser = useSelector(state => state.users.current_user.user_id_number)
    const trainerParam = useSelector(selectTrainerParam)
    const [addingEvent,setAddingEvent] = useState(false)
    const { selectedClient: client_id,selectedDate } = useSelector(state => (state.allEvents.selectedEventInfo))
    const user = useCurrentUser()

    const handleClick = (eventType)=>{
        setAddingEvent(true)
        envAwarePost('api/events/',{
            action: 'createEvent',
            is_favorite: client_id === 'favorite' && !isClient ? 1 : 0,
            event_type: eventType,
            date: client_id === 'favorite' && !isClient? "1969-12-31" : selectedDate,
            title: '',
            client_id:user.account_type === 'client'?user.user_id_number:client_id
        }).then(res=>{
            setAddingEvent(false)
            if(res.success==='0'){
                window.alert(res.message)
                return
            }
            const event_id = res.data[`${eventType}_id`]
            const editorRoute = `/eventEditor/?event_id=${event_id}&event_type=AddOrEdit&eventType=${capitalize(eventType)}&client=${isClient ? clientIdUser : (client_id ? client_id :  'favorite')}&${trainerParam}`
            dispatch(getEvents({
                event_type:eventType,
                client_id:user.account_type === 'client'?user.user_id_number:client_id,
                filter:'client'
            }))
            history.push(editorRoute)
        })
    }
    return (
        <Modal
            show={selectEventShow}
            className='event-info-modal '
            onHide={() => { setSelectEventShow(false) }}
            style={{ display: 'flex !important', flexDirection: 'column', alignItems: 'center' }}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: "20px" }} className="p-2 m-2">Select Event Type To Add</Modal.Title>
            </Modal.Header>
            <hr style={{ width: '100%', margin: '0px' }} />
            <Modal.Body style={{ width: '100%' }}>
                <Row>
                    <Col className='button-column'>
                        <Button
                            disabled={addingEvent}
                            className="ml-1"
                            onClick={handleClick.bind(null,'workout')}
                            style={{ backgroundColor: '#B6F0EE', borderColor: '#B6F0EE', color: 'black' }}
                        >
                            Workout {addingEvent&&<Spinner animation="border" size="sm"/>}
                        </Button>
                    </Col>
                    <Col className='button-column'>
                        <Button
                            disabled={addingEvent}
                            className="ml-1"
                            onClick={handleClick.bind(null,'nutrition')}
                            style={{ backgroundColor: '#F0D19E', borderColor: '#F0D19E', color: 'black' }}
                        >
                            Nutrition {addingEvent&&<Spinner animation="border" size="sm"/>}
                        </Button>
                    </Col>
                    <Col className='button-column'>
                        <Button
                            disabled={addingEvent}
                            className="ml-1"
                            onClick={handleClick.bind(null,'task')}
                            style={{ backgroundColor: '#AAF0C6', borderColor: '#AAF0C6', color: 'black' }}
                        >
                            Task {addingEvent&&<Spinner animation="border" size="sm"/>}
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>)
}

export default SelectEventType